import { Dialog, Button, ButtonGroup, Flex, Text } from '@/_components';
import { FC } from 'react';
import { DeleteQuestionConfirmProps } from './DeleteQuestionConfirm.types';

export const DeleteQuestionConfirm: FC<DeleteQuestionConfirmProps> = ({
  isLoading,
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Delete Question">
      <Dialog.Content>
        <Flex isColumn={true} gap={8}>
          <Text>Are you sure you want to delete this question?</Text>
          <ButtonGroup align="right">
            <Button
              value="Keep Question"
              onClick={onClose}
              intent="secondary"
              isDisabled={isLoading}
            />
            <Button
              value="Delete Question"
              iconLeft="trash"
              onClick={onConfirm}
              intent="danger"
              isDisabled={isLoading}
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
